<template>
  <ul class="paymentTab">
    <li
      v-for="item in list"
      :key="item.value"
      class="paymentTab__list"
      :class="{'paymentTab__list--active': active === item.value}"
      @click="$emit('active', item.value)"
    >
      {{ item.text }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'PaymentTab',
  props: {
    list: Array,
    active: String,
  },
}
</script>

<style scoped lang="scss">
@import '../../../../../sass/commons/commonVariables.scss';

.paymentTab {
  margin: 24px auto;
  width: 80.8%;
  max-width: 303px;
  padding: 0;
  display: flex;
  &__list {
    flex: 1 1 50%;
    list-style: none;
    font-size: 12px;
    line-height: 1;
    text-align: center;
    color: $academy_purple;
    border: 1px solid $academy_purple;
    box-sizing: border-box;
    background: #fff;
    padding: 12px 0;
    transition: 0.3s;
    cursor: pointer;
    &--active {
      color: #FFF;
      background: $academy_purple3;
      border-color: $academy_purple3;
      cursor: default;
    }
    &:first-child {
      border-radius: 4px 0 0 4px;
    }
    &:last-child {
      border-radius: 0 4px 4px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Academy/partials/PaymentTab.vue